import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from 'react-tooltip';


import Notification from '../notification';
import styles from './styles.css';

import BPUtils from '../../../lib/bputils';

const WATCH_TOOLTIP_MSG = 'By watching this station, it will be more visible to you across the dashboard';

export default function WatchStation({
  stationId,
  isWatched,
  onToggle,
  iconHeight,
  className,
  tooltip,
  ...rest
}) {
  const [watching, setWatching] = React.useState(isWatched);

  React.useEffect(() => {
    setWatching(isWatched);
  }, [isWatched, stationId]);

  const handleOnWatch = () => {
    BPUtils.api[watching ? 'delete' : 'post']({
      path: `/stations/${stationId}/watch`,
      requestId: 'toggleStationWatched',
      success: () => {
        setWatching(!watching);
        onToggle({ id: stationId, watched: !watching });
      },
      error: () => Notification.error('There was an error while attempting to watch this station. Please contact support.'),
    });
  };

  return (
    <div className={`${styles.watchedContainer} ${className}`} {...rest}>
      <FontAwesomeIcon
        icon={faEye}
        onClick={handleOnWatch}
        className={`${styles.watchedImg} ${watching && styles.watched}`}
        style={{ fontSize: `${iconHeight}px` }}
        data-tip
        data-for={`watch-icon-${stationId}`}
      />
      { tooltip ? (
        <ReactTooltip id={`watch-icon-${stationId}`} place="top" effect="solid" className={styles.watchStationTooltip}>
          {WATCH_TOOLTIP_MSG}
        </ReactTooltip>
      ) : null}
    </div>
  );
}

WatchStation.propTypes = {
  stationId: PropTypes.number,
  isWatched: PropTypes.bool,
  onToggle: PropTypes.func,
  iconHeight: PropTypes.number,
  tooltip: PropTypes.bool,
  className: PropTypes.string,
};

WatchStation.defaultProps = {
  stationId: 0,
  isWatched: false,
  onToggle: () => { },
  iconHeight: 18,
  tooltip: false,
  className: '',
};
